import Vue from 'vue';
import {AxiosResponse, AxiosError} from 'axios';
import {mapGetters, mapActions, mapState} from 'vuex';
import {EmployeeProfileModuleConstant, MemberSearchModuleConstant, UrlModuleConstant} from '../../lib/constants';
import {ErrorType} from '../../lib/enums';
import MemberSearchResults from './memberSearchResults.html';
import MomentFilter from '../../lib/filters/momentFilter';
import {coachService} from '../../lib/services/coachService';
import TrainerizeUrlService from '../../lib/services/trainerizeUrlService';
import MobileUtils from '../../lib/helpers/mobileUtils';
import EcMemberSearch from '../../../types/ec/ecMemberSearch';
import EcCommon from '../../../types/ec/ecCommon';
import LtCommon from '../../../types/lt/ltCommon';

interface IComponentData {
	coachService: EcCommon.ICoachService;
	mobileUtils: LtCommon.IMobileUtils;
}

export default Vue.component('ecMemberSearchResults', {
	template: MemberSearchResults,
	data(): IComponentData {
		return {
			coachService,
			mobileUtils: {} as LtCommon.IMobileUtils,
		};
	},
	props: {
		searching: Boolean,
		searchText: String,
	},
	computed: {
		...mapGetters(EmployeeProfileModuleConstant.name,  {
			getIsEmployeeProfileValid: EmployeeProfileModuleConstant.getter.getIsValid,
		}),
		...mapGetters(UrlModuleConstant.name, [UrlModuleConstant.getter.getGlobalPageDriverUrl]),
		...mapState(EmployeeProfileModuleConstant.name, [EmployeeProfileModuleConstant.state.employeeProfile]),
		...mapState(MemberSearchModuleConstant.name, [MemberSearchModuleConstant.state.members]),
	},
	methods: {
		requestConnection(member: EcMemberSearch.IMember, index: number): Promise<void> {
			if (member && member.emailAddress) {
				return this.coachService.setClientConnection(this.employeeProfile.partyId, member.partyId)
					.then((response: AxiosResponse) => {
						if (this.employeeProfile.employeeDetails) {
							const trainerDetails: EcCommon.ITrainerDetails = {
								firstName: this.employeeProfile.employeeDetails.firstName,
								lastName: this.employeeProfile.employeeDetails.lastName,
								partyId: this.employeeProfile.employeeDetails.partyId,
								index,
							};
							this.setTrainerDetails(trainerDetails);
						}

						return this.updateConnectedStatus(member);
					}, (error: AxiosError) => {
						if (error && error.response && error.response.data && error.response.data.errorType === ErrorType.DuplicateEmailAddress) {
							this.showInvalidEmailAddressMessage(member.partyId);
						}
					});
			} else {
				return this.showInvalidEmailAddressMessage(member.partyId);
			}
		},
		showConnectClientModal(index: number): void {
			$('#connectClientModal' + index).modal('show');
		},
		connect(member: EcMemberSearch.IMember, index: number): Promise<void> {
			$('#connectClientModal' + index).modal('hide');
			return this.requestConnection(member, index - 1);
		},
		showInvalidEmailAddressMessage(partyId: number): Promise<void> {
			return this.setEmailAddressInvalid(partyId);
		},
		viewTrainingProgram(member: EcMemberSearch.IMember): void {
			if (this.mobileUtils.isMobile) {
				const appWindow = window.open('trainerize://', '_self');
				setTimeout(() => {
					if (appWindow) {
						window.location.assign(this.mobileUtils.storeUrl);
					}
				}, 1000);
			} else {
				const newWindow = window.open('', '_blank');
				Promise.all([this.coachService.getSSOForTrainerize(this.employeeProfile.partyId), this.coachService.getClientUserIdInTrainerize(member.partyId)])
					.then((response: AxiosResponse<EcCommon.ITrainerizeToken | EcCommon.IClientUserId>[]) => {
						const params: LtCommon.IParamsObject = {
							url: 'trainingplan',
							clientid: (response[1].data as EcCommon.IClientUserId).userID,
							logintoken: (response[0].data as EcCommon.ITrainerizeToken).token,
							userID: (response[0].data as EcCommon.ITrainerizeToken).sourceId,
						};

						const trainerizeUrl: string = TrainerizeUrlService.getTrainerizeUrl(params);
						if (newWindow) {
							newWindow.location.assign(trainerizeUrl);
						}
					});
			}

		},
		...mapActions(MemberSearchModuleConstant.name, [
			MemberSearchModuleConstant.action.setTrainerDetails,
			MemberSearchModuleConstant.action.updateConnectedStatus,
			MemberSearchModuleConstant.action.setEmailAddressInvalid
		]),
	},
	filters: {
		momentFilter: MomentFilter,
	},
	created(): void {
		this.mobileUtils = MobileUtils();
	},
});
